/**
 * Résumé d'importation de paramètres — EF-PAR-003. Aucune fusion partielle :
 * l'utilisateur confirme ou annule la totalité.
 */

import type { JSX } from 'preact';
import { applyParameterImport, parameterImportSummary } from '../state';

export function ParameterImportDialog(): JSX.Element | null {
  const summary = parameterImportSummary.value;
  if (summary === null) return null;

  return (
    <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label="Importer des paramètres">
      <div class="modal">
        <h2 style="margin-top:0;">Paramètres à remplacer</h2>

        {summary.changes.length === 0 ? (
          <p>Aucune valeur ne change.</p>
        ) : (
          <div class="scroll-x">
            <table class="table">
              <thead>
                <tr>
                  <th>Réglage</th>
                  <th>Ancienne valeur</th>
                  <th>Nouvelle valeur</th>
                </tr>
              </thead>
              <tbody>
                {summary.changes.map((change) => (
                  <tr key={change.field}>
                    <td>{change.field}</td>
                    <td>{change.before}</td>
                    <td>{change.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <h3>Conséquences sur l’état courant</h3>
        <ul>
          <li>{summary.hiddenPoiCount} POI deviendront masqués par les filtres importés.</li>
          <li>{summary.outOfCorridorCount} POI n’auront plus aucun passage dans le nouveau corridor.</li>
          <li>Les valeurs calculées seront marquées périmées : les paramètres de calcul font partie du fichier.</li>
        </ul>
        <p class="muted">
          Ces conséquences sont informatives : l’importation ne modifie ni les POI, ni la curation, ni les
          résultats enregistrés.
        </p>

        <div class="actions">
          <button
            type="button"
            onClick={() => {
              parameterImportSummary.value = null;
            }}
          >
            Annuler
          </button>
          <button
            type="button"
            class="primary"
            onClick={() => {
              void applyParameterImport();
            }}
          >
            Remplacer les paramètres
          </button>
        </div>
      </div>
    </div>
  );
}
